module.exports = __webpack_public_path__ + "media/usp-mealplans-0a2885b2.svg";